import { typography } from './../typography/index'
import { css } from 'styled-components'
import { color, colors } from '../colors'
import { media } from '@rst/libs-ts'
export { innerHtmlCss } from './inner-html'

export const shadowCss = css`
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
`

const getPrimary = (x: typeof colors) => {
	const { main } = x.primary
	if (main.length === 7) return main
	const hash = main.indexOf('#')
	if (hash === -1) return main
	return main.slice(hash, hash + 7)
}

export const loadingAnimationCss = () => css`
	@keyframes loadingAnimation {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.7;
		}
		100% {
			opacity: 1;
		}
	}

	animation: loadingAnimation 1.5s infinite;
`
export const hiddenScrollCss = css`
	&::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}
	&::-webkit-scrollbar-thumb {
		width: 0px;
		height: 0px;
	}
`

export const htmlTextStyle = css`
	font-family: ${({ theme }) =>
		`${theme?.font?.main || 'Inter'}, ${
			theme?.font?.family_main || 'sans-serif'
		}`};
	& * {
		font-family: ${({ theme }) =>
			`${theme?.font?.main || 'Inter'}, ${
				theme?.font?.family_main || 'sans-serif'
			}`};
	}
	ul,
	ol {
		margin-bottom: 24px;
		padding-left: ${({ theme }) => (theme.rtl ? null : '30px')};
		padding-right: ${({ theme }) => (theme.rtl ? '30px' : null)};

		li {
			margin-bottom: 8px;
			list-style: none;
			position: relative;
			text-align: ${({ theme }) => (theme.rtl ? 'right' : null)};
		}
		${media.pure.less(media.size.xs)} {
			padding-left: 25px;
		}
	}

	ul li {
		&:before {
			position: absolute;
			content: '';
			left: ${({ theme }) => (theme.rtl ? null : '-25px')};
			right: ${({ theme }) => (theme.rtl ? '-25px' : null)};
			top: 5px;
			background: ${color(getPrimary)};
			width: 10px;
			height: 10px;
			border-radius: 50%;
			${media.pure.less(media.size.xs)} {
				width: 8px;
				height: 8px;
				left: ${({ theme }) => (theme.rtl ? null : '-20px')};
				right: ${({ theme }) => (theme.rtl ? '-20px' : null)};
			}
		}
	}

	ol {
		counter-reset: myCounter;
		li {
			&:before {
				counter-increment: myCounter;
				content: counter(myCounter);
				color: ${color(getPrimary)};
				font-size: 16px;
				font-weight: 700;
				position: absolute;
				left: ${({ theme }) => (theme.rtl ? null : '-25px')};
				right: ${({ theme }) => (theme.rtl ? '-25px' : null)};
				top: 0px;
				${media.pure.less(media.size.xs)} {
					left: ${({ theme }) => (theme.rtl ? null : '-20px')};
					right: ${({ theme }) => (theme.rtl ? '-20px' : null)};
					font-size: 14px;
				}
			}
		}
	}
	a {
		color: ${color(getPrimary)};
		text-decoration: none;
	}

	p {
		margin-bottom: 16px;
		${typography.body.regular};
		&:last-child {
			margin-bottom: 0px;
		}
	}

	img {
		width: 100% !important;
		height: auto !important;
	}

	h2 {
		${typography.head2.bold};
		//letter-spacing: 0.02em;
		margin-bottom: 16px;
	}
	h3 {
		${typography.head3.bold};
		margin-bottom: 16px;
	}
`

export const getThemedBorderRadius = ({
	theme,
}: {
	theme: { borderRadius?: number }
}) => (theme?.borderRadius == null ? '8px' : `${theme.borderRadius}px`)

export const themedBorderRadius = css`
	border-radius: ${getThemedBorderRadius};
`
export const themedInputBorderRadius = css`
	border-radius: ${({ theme }) =>
		`${
			theme?.inputBorderRadius === undefined ? 10 : theme.inputBorderRadius
		}px`};
`
export * from './inner-html2'

export { HTMLGlobalStyle } from './html-global-style'
